import { useEffect, useState } from 'react';

export function useSearch<T>(fn: (q: string, signal: AbortSignal) => Promise<T[]>, query: string, resetKey: string) {
  const [results, setResults] = useState<T[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { setResults([]); setError(''); }, [resetKey]);
  useEffect(() => {
    const q = query.trim();
    if (q.length < 2) { setResults([]); setLoading(false); setError(''); return; }
    const ctrl = new AbortController();
    setLoading(true); setError('');
    const t = setTimeout(() => {
      fn(q, ctrl.signal)
        .then((r) => { if (!ctrl.signal.aborted) { setResults(r); setLoading(false); } })
        .catch((e) => { if (!ctrl.signal.aborted) { setError(e.message || 'Search failed'); setLoading(false); } });
    }, 350);
    return () => { clearTimeout(t); ctrl.abort(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, resetKey]);
  return { results, loading, error };
}
